import { create } from 'zustand';

/** Session-only admin reasons for private WorkGroup access (not persisted server-side). */
export const WORKGROUPS_PRIVATE_REASON_MIN_LEN = 8;

interface WorkgroupsUIState {
  selectedWorkGroupId: string | null;
  selectedFolderId: string | null;
  activeDialog: string | null;
  selectedFileId: string | null;
  /** workGroupId → reason (UI session only). */
  privateAccessByWorkGroupId: Record<string, string>;
  setSelectedWorkGroupId: (id: string | null) => void;
  setSelectedFolderId: (id: string | null) => void;
  openDialog: (id: string) => void;
  closeDialog: () => void;
  setSelectedFileId: (id: string | null) => void;
  setPrivateAccessReason: (workGroupId: string, reason: string) => void;
  clearPrivateAccessReason: (workGroupId: string) => void;
}

export const useWorkgroupsUIStore = create<WorkgroupsUIState>((set) => ({
  selectedWorkGroupId: null,
  selectedFolderId: null,
  activeDialog: null,
  selectedFileId: null,
  privateAccessByWorkGroupId: {},
  setSelectedWorkGroupId: (id) => set({ selectedWorkGroupId: id }),
  setSelectedFolderId: (id) => set({ selectedFolderId: id }),
  openDialog: (id) => set({ activeDialog: id }),
  closeDialog: () => set({ activeDialog: null }),
  setSelectedFileId: (id) => set({ selectedFileId: id }),
  setPrivateAccessReason: (workGroupId, reason) =>
    set((state) => ({
      privateAccessByWorkGroupId: {
        ...state.privateAccessByWorkGroupId,
        [workGroupId]: reason.trim(),
      },
    })),
  clearPrivateAccessReason: (workGroupId) =>
    set((state) => {
      const next = { ...state.privateAccessByWorkGroupId };
      delete next[workGroupId];
      return { privateAccessByWorkGroupId: next };
    }),
}));
